import React  from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import Issue from 'Pages/Issue';
import Header from 'Components/Header';
import Footer from 'Components/Footer';
import SocketChat from 'Components/SocketChat';
import Toast from 'Components/Toast';
// import MoemeQna from "Components/MoemeQna";



const PageFrame = ({ location, history }) => {

  return (
    <>
      <SocketChat />
      <Header />
      <div id="contents">
        <div className="inwrap">
          <Switch>
            <Route path="/web/issue" component={Issue} />
            <Redirect exact path="/web" to="/web/issue" />
            <Redirect path="*" to="/error" />
          </Switch>
        </div>
      </div>
      <Footer />
      {/* { location.pathname === '/web/issue' ? (<MoemeQna />) : null } */}
      <Toast />
    </>
  )
}

export default PageFrame;